import { Product } from 'BrokerTsLib/src/enums'

export const Apis = {
  account: 0,
  vinOnline: 1,
  user: 2,
  appInfoMessage: 3,
  document: 4,
  enum: 5,
  wizard: 6,
  addonWizard: 7,
  offer: 8,
  offerAddon: 9,
  insuranceParams: 10,
  statistics: 11,
  poleas: 12,
  poleasEssox: 13,
  ppzAuthorization: 14,
  insuranceDraft: 15,
  mailing: 16,
  poleasPublic: 17,
  poleasWizard: 18,
  poleasEnum: 19,
  poleasOffer: 20,
  commissions: 21,
  preContractDocument: 22,
  translations: 23,
  publicEmail: 24,
  person: 25,
  errorHandlingSagas: 26,
  exceptionalDiscount: 27,
} as const

export type Apis = typeof Apis[keyof typeof Apis]

export type Environment = 'development' | 'test' | 'prep' | 'production'

const env = import.meta.env
export const environment = env.VITE_ENVIRONMENT! as Environment

export const AppSettings = {
  enviroment: environment,
  baseUrl: env.VITE_BASE_URL,
  signalRHub: env.VITE_CALCULATION_HUB,
  api: {
    [Apis.account]: env.VITE_ACCOUNT_API,
    [Apis.user]: env.VITE_USER_API,
    [Apis.appInfoMessage]: env.VITE_APP_INFO_API,
    [Apis.poleas]: env.VITE_POLEAS_API,
    [Apis.poleasPublic]: env.VITE_POLEASPUBLIC_API,
    [Apis.poleasEssox]: env.VITE_POLEAS_ESSOX_API,
    [Apis.offerAddon]: env.VITE_OFFERADDON_VEHICLE_API,
    [Apis.addonWizard]: env.VITE_ADDONWIZARD_VEHICLE_API,
    [Apis.poleasWizard]: env.VITE_WIZARD_POLEAS_API,
    [Apis.poleasOffer]: env.VITE_OFFER_POLEAS_API,
    [Apis.poleasEnum]: env.VITE_ENUM_POLEAS_API,
    [Apis.ppzAuthorization]: env.VITE_PPZAUTHORIZATION_API,
    [Apis.commissions]: env.VITE_COMMISSIONS_API,
    [Apis.person]: env.VITE_PERSON_API,
    [Apis.preContractDocument]: env.VITE_PRE_CONTRACT_DOCUMENT_API,
    [Apis.translations]: env.VITE_PRE_TRANSLATIONS_API,
    [Apis.publicEmail]: env.VITE_PUBLICEMAIL_API,
    [Apis.errorHandlingSagas]: 'api/ErrorHandlingSagas',
    [Apis.exceptionalDiscount]: 'api/ExceptionalDiscount',
    [Apis.vinOnline]: {
      [Product.VehicleInsurance]: env.VITE_VINONLINE_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_VINONLINE_LEASING_API,
      [Product.TravelInsurance]: env.VITE_VINONLINE_VEHICLE_API,
    },
    [Apis.mailing]: {
      [Product.VehicleInsurance]: env.VITE_MAILING_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_MAILING_VEHICLE_API,
      [Product.TravelInsurance]: env.VITE_MAILING_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_MAILING_VEHICLE_API,
      [Product.PropertyInsurance]: env.VITE_MAILING_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_MAILING_LIABILITY_API,
    },
    [Apis.enum]: {
      [Product.VehicleInsurance]: env.VITE_ENUM_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_ENUM_LEASING_API,
      [Product.TravelInsurance]: env.VITE_ENUM_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_ENUM_FLEET_API,
      [Product.PropertyInsurance]: env.VITE_ENUM_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_ENUM_LIABILITY_API,
    },
    [Apis.wizard]: {
      [Product.VehicleInsurance]: env.VITE_WIZARD_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_WIZARD_LEASING_API,
      [Product.TravelInsurance]: env.VITE_WIZARD_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_WIZARD_FLEET_API,
      [Product.PropertyInsurance]: env.VITE_WIZARD_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_WIZARD_LIABILITY_API,
    },
    [Apis.offer]: {
      [Product.VehicleInsurance]: env.VITE_OFFER_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_OFFER_LEASING_API,
      [Product.TravelInsurance]: env.VITE_OFFER_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_OFFER_FLEET_API,
      [Product.PropertyInsurance]: env.VITE_OFFER_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_OFFER_LIABILITY_API,
    },
    [Apis.insuranceParams]: {
      [Product.VehicleInsurance]: env.VITE_INSURANCEPARAMS_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_INSURANCEPARAMS_LEASING_API,
      [Product.TravelInsurance]: env.VITE_INSURANCEPARAMS_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_INSURANCEPARAMS_FLEET_API,
      [Product.PropertyInsurance]: env.VITE_INSURANCEPARAMS_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_INSURANCEPARAMS_LIABILITY_API,
    },
    [Apis.document]: {
      [Product.VehicleInsurance]: env.VITE_DOCUMENT_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_DOCUMENT_LEASING_API,
      [Product.TravelInsurance]: env.VITE_DOCUMENT_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_DOCUMENT_FLEET_API,
      [Product.PropertyInsurance]: env.VITE_DOCUMENT_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_DOCUMENT_LIABILITY_API,
    },
    [Apis.statistics]: {
      [Product.VehicleInsurance]: env.VITE_STATISTICS_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_STATISTICS_LEASING_API,
      [Product.TravelInsurance]: env.VITE_STATISTICS_TRAVEL_API,
      [Product.FleetInsurance]: env.VITE_STATISTICS_FLEET_API,
      [Product.PropertyInsurance]: env.VITE_STATISTICS_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_STATISTICS_PROPERTY_API,
    },
    [Apis.insuranceDraft]: {
      [Product.VehicleInsurance]: env.VITE_INSURANCEDRAFT_VEHICLE_API,
      [Product.VehicleLeasingInsurance]: env.VITE_INSURANCEDRAFT_VEHICLE_API,
      [Product.FleetInsurance]: env.VITE_INSURANCEDRAFT_VEHICLE_API,
      [Product.PropertyInsurance]: env.VITE_INSURANCEDRAFT_PROPERTY_API,
      [Product.LiabilityInsurance]: env.VITE_INSURANCEDRAFT_PROPERTY_API,
    },
  },
}